module.exports = {"url":"https://arbopasto.cnpgc.embrapa.br","api":"/services/trees_list_json.php?TOKEN_ACCESS=0dc72402be6fe1c1321a5062058696f1","image_base64":"/libraries/php-image-resize/lib/index64.php?w=450&h=450&image_path=","image_crop":"/libraries/php-image-resize/lib/index.php?w=450&h=450&image_path=","status":"/services/status.php","analytics":"UA-124202509-4","tracking":{"host":"https://bug.cnpgc.embrapa.br","key":"409619fc535e338fe598cfe0613438bb"},"support":"arbopasto@embrapa.br"}


//////////////////
// WEBPACK FOOTER
// ./src/settings/production.json
// module id = 132
// module chunks = 3